module.exports = __webpack_public_path__ + "img/0114.c0ab4652.png";